import {
	formatPrice as formatHyperliquidPrice,
	formatSize as formatHyperliquidSize,
} from "@nktkas/hyperliquid/utils";

function toDecimalString(value: string | number): string {
	if (typeof value === "number") {
		return value.toLocaleString("en-US", {
			useGrouping: false,
			maximumSignificantDigits: 15,
		});
	}

	return value.trim();
}

export function normalizePerpOrderPrice(
	price: string | number,
	szDecimals: number,
): string {
	return formatHyperliquidPrice(toDecimalString(price), szDecimals, "perp");
}

export function normalizeOrderSize(
	size: string | number,
	szDecimals: number,
): string {
	return formatHyperliquidSize(toDecimalString(size), szDecimals);
}
